// extracted by mini-css-extract-plugin
export var container = "_bp-0";
export var containerTopRight = "_bp-1";